import { CheckoutParamEnum } from 'components/views/pages/Checkout/types';
import { LoginState } from 'components/views/pages/_general/useLoginState';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

export const useEnsureLoggedInCheckout = (loginState: LoginState) => {
  const router = useRouter();
  useEffect(() => {
    if (loginState === 'notloggedin') {
      toast.error('You must be logged in!');
      router.replace({
        pathname: router.pathname,
        query: { ...router.query, [CheckoutParamEnum.step]: 1 },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState]);
};
